module.exports = __webpack_public_path__ + "static/media/r3.e54f5a9b.png";